import { Instance } from 'mobx-state-tree';
import model from './model';
import views from './views';

const Template = model.views(views);

export interface ITemplate extends Instance<typeof Template> {}

export default Template;
